import React, {PureComponent} from 'react'
import injectSheet from 'react-jss'
import CentredContentContainer from "../Widgets/CentredContentContainer"
import Advert from "./Advert"

class AdvertBannerSlice extends PureComponent {
  render() {
    const { classes, item } = this.props;
    const { image, content_order, text_align, title, heading, text, button_link } = item;
    return (
      <CentredContentContainer>
        <section className={classes.section}>
          <Advert
            image={image}
            contentOrder={content_order}
            alignCopy={text_align}
            title={title}
            heading={heading}
            text={text}
            buttonLink={button_link}
            classes={classes}
            showHeading
          />
        </section>
      </CentredContentContainer>
    )
  }
}

export default injectSheet(
  {
    section: {
      borderTop: '1px solid #B0B0B0',
      borderBottom: '1px solid #B0B0B0',
    },
  }
)(AdvertBannerSlice)



// WEBPACK FOOTER //
// ./src/components/Article/AdvertBannerSlice.js